import React from "react";
import styled from "styled-components";
import {
  GlossyThemeProvider,
  ZIndexes,
  background,
  border,
  prettyScrollbars,
} from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import { tr } from "@radarly/i18n";

export interface IProps {
  card: React.ReactNode;
  sidebar: React.ReactNode;
  overlay?: React.ReactNode;
  onClickBack?: () => void;
  locale: Locale;
}

const Root = styled.div`
  display: flex;
  position: relative;
  z-index: ${ZIndexes.Content};
  width: 100%;
  height: 100%;
  background-color: ${background};
`;

const Body = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  overflow: auto;
  > * {
    width: calc(100% - 96px);
    max-height: calc(100% - 128px);
    max-width: 1800px;
  }
`;

const Sidebar = styled.div`
  flex: 320px 0 0;
  ${prettyScrollbars()};
  border-left: solid 1px ${border};
`;

const BackButton = styled(Button)`
  position: absolute;
  left: 12px;
  top: 12px;
  width: auto;
`;

const PanelsCardEditionForm = ({
  card,
  sidebar,
  overlay,
  onClickBack,
  locale,
}: IProps) => (
  <GlossyThemeProvider name="edition">
    <Root>
      {overlay}
      <Body>
        <BackButton
          icon="arrow-left"
          text={tr(locale, "CUSTOM_PAGES::EDITOR::BACK_TO_CARDS_LIST")}
          size="m"
          variant="tertiary"
          onClick={onClickBack}
        />
        {card}
      </Body>
      {sidebar && <Sidebar>{sidebar}</Sidebar>}
    </Root>
  </GlossyThemeProvider>
);

export default PanelsCardEditionForm;
